export const solutionsSubMenu = [
  {
    id: 1,
    link: "#our-solutions",
    label: "Our Solutions",
  },
  {
    id: 2,
    link: "#colocation",
    label: "Colocation",
  },
  {
    id: 3,
    link: "#sale-and-leaseback",
    label: "Sale & leaseback",
  },
  {
    id: 4,
    link: "#managed-services",
    label: "Managed services",
  },
];
